export default "__VITE_ASSET__e828069d__"